import { Dialog, DialogContent, DialogTitle, Grid2 } from '@mui/material';
import MButton from '../../../components/inputs/yup/materialui/mButton';
import { RowComprobanteLiquidacion } from '../models/headerComprobanteLiquidacion';
import * as Yup from "yup";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { UseLiquidacion } from '../hooks/useLiquidacion';
import { FormularioBeneficiarioModel } from '../models/formularioBeneficiarioModel';
import { useEffect, useState } from 'react';
import InputText from '../../../components/inputs/yup/materialui/inputText';
import InputRut from '../../../components/inputs/yup/materialui/inputRut';
import InputNumber from '../../../components/inputs/yup/materialui/inputNumber';
import InputSelect from '../../../components/inputs/yup/materialui/inputSelect';
import { useGarantias } from '../../detalleMutuo/hooks/useGarantias';
import ModalInmobiliarias from '../../detalleMutuo/components/garantias/modalInmobiliarias';
import inmobiliariaDto from '../../maestros/inmobiliarias/models/inmobiliariaDto';
import SearchIcon from '@mui/icons-material/Search';
import { TipoBeneficiario, ValuesTipoBeneficiario } from '../enums/tipoBeneficiario';
import ConfirmationModal from '../../../components/ui/materialui/confirmationModal';
import { useParticipantes } from '../../detalleMutuo/hooks/useParticipantes';
import { ParticipanteRequest } from '../../detalleMutuo/models/participantes';
import { selectorTransversal } from '../../../dtos/selector';
import validaRut from '../../../utils/validaRut';

interface IProps {
    idMutuo: number
    show: boolean;
    onHide: () => void;
    isCreating: boolean;
    rowInfo: RowComprobanteLiquidacion | null;
    onSubmit: any;
    onUpdate: any;
}

const schema = Yup.object<FormularioBeneficiarioModel>().shape({
    rut: Yup.string().required('RUT es requerido').test('valida-rut', 'RUT inválido', function (value) {
            return validaRut.rutFormat(value);
    }).max(12, 'Máximo 12 caractéres'),
    nombre: Yup.string().required('Nombre requerido'),
    apellidoPaterno: Yup.string().required('Aepllido Paterno Requerido'),
    apellidoMaterno: Yup.string().required('Apellido Materno Requerido'),
    monto: Yup.number().min(1, 'El monto del beneficiario debe ser positivo').required('Monto requerido'),
    tipoBeneficario: Yup.string().required('Tipo beneficiario requerido'),
    inmobiliaria: Yup.string().required('Debe seleccionar una inmobiliaria'),
    institucion: Yup.string().required('Debe seleccionar una institución financiera'),
    participante: Yup.string().required('Debe seleccionar un participante'),
})

const ModalLiquidacion: React.FC<IProps> = ({idMutuo, show, onHide, isCreating, rowInfo, onSubmit, onUpdate}) => {

    const { defaultValuesRowBeneficiario, setDefaultValuesRowBeneficiario} = UseLiquidacion();
    const { listInstitucionFinan, listarInstitucionFinanciera } = useGarantias();
    const { listaParticipantes, getParticipantes, buscarParticipante} = useParticipantes();

    const [showModalInmobiliaria, setShowModalInmobiliaria] = useState<boolean>(false);
    const [tablaSeleccionada, setTablaSeleccionada] = useState<inmobiliariaDto>();

    const [isEditingDefining, setIsEditingDefining] = useState<boolean>(!isCreating);
    const [participantes, setParticipantes] = useState<selectorTransversal[]>([]);

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const {
            control,
            formState: { errors },
            handleSubmit,
            setValue,
            reset,
            clearErrors,
            watch
        } = useForm<FormularioBeneficiarioModel>({
            defaultValues: defaultValuesRowBeneficiario,
            resolver: yupResolver(schema),
            mode: 'onChange',
        })

    const tipoBeneficarioWatcher = watch("tipoBeneficario");
    const institucionWatcher = watch("institucion");
    const participanteWatcher = watch("participante");

    useEffect(() => {
        if (show){
            setIsEditingDefining(!isCreating);
        }
    }, [isCreating, show])

    useEffect(() => {
        if (show){
            if (!isCreating && rowInfo){
                const tipoBeneficiarioLabel = rowInfo?.tipoBeneficiario === TipoBeneficiario.PERSONA_NATURAL ? ValuesTipoBeneficiario.PERSONA_NATURAL : 
                                                rowInfo?.tipoBeneficiario === TipoBeneficiario.INSTITUCION_FINANCIERA ? ValuesTipoBeneficiario.INSTITUCION_FINANCIERA : 
                                                rowInfo?.tipoBeneficiario === TipoBeneficiario.INMOBILIARIA ? ValuesTipoBeneficiario.INMOBILIARIA : "";
                const rowInfoMapped : FormularioBeneficiarioModel = {
                    nombre: rowInfo?.nombre ?? "", 
                    apellidoPaterno: rowInfo.apellidoPaterno !== "" ? (rowInfo.apellidoPaterno ?? "AP") : "AP", 
                    apellidoMaterno: rowInfo.apellidoMaterno !== "" ? (rowInfo.apellidoMaterno ?? "AM") : "AM", 
                    rut: rowInfo?.rut ?? "",
                    rutOriginal: rowInfo?.rut ?? "",
                    monto: rowInfo?.monto ?? 0,
                    tipoBeneficario: tipoBeneficiarioLabel,
                    inmobiliaria: (tipoBeneficiarioLabel === ValuesTipoBeneficiario.INMOBILIARIA) ? (rowInfo?.nombre ?? "") : "IF",
                    institucion: (tipoBeneficiarioLabel === ValuesTipoBeneficiario.INSTITUCION_FINANCIERA) ? (rowInfo?.rut ?? "") : "IN",
                    participante: "PA"
                }
                setDefaultValuesRowBeneficiario(rowInfoMapped);
            }
            else{
                setValue("tipoBeneficario", "")
            }
            listarInstitucionFinanciera();
        }    
    },[show, rowInfo])

    useEffect(() => {
        getParticipantes(idMutuo);
    }, [show, idMutuo])

    useEffect(() => {
        const selectParticipantes : selectorTransversal[] = []
        for (const participante of listaParticipantes){
            selectParticipantes.push({label: participante.nombre, value: participante.rut + "/" + participante.idTipoParticipante})
        }
        setParticipantes(selectParticipantes)
    }, [listaParticipantes])

    useEffect(() => {
        reset(defaultValuesRowBeneficiario)
    }, [defaultValuesRowBeneficiario])

    useEffect(() => {
        if (tipoBeneficarioWatcher === ValuesTipoBeneficiario.INSTITUCION_FINANCIERA){
            const institucion = listInstitucionFinan.find((index) => index.value === institucionWatcher)
            setValue("nombre", institucion?.label.toString() ?? "");
            setValue("rut", institucion?.value.toString() ?? "")
        } 
    }, [institucionWatcher])

    useEffect(() => {
        if (tablaSeleccionada) {
            setValue('inmobiliaria', tablaSeleccionada?.nombre);
            setValue('nombre', tablaSeleccionada?.nombre);
            setValue('rut', tablaSeleccionada?.rut);
        }
    }, [tablaSeleccionada]);

    useEffect(() => {
        if (!isEditingDefining){
            clearErrors()
            setValue("nombre", "")
            setValue("rut", "")
            setValue("monto", 0)
            
            if (tipoBeneficarioWatcher === ValuesTipoBeneficiario.PERSONA_NATURAL){
                setValue("inmobiliaria", "IF")
                setValue("institucion", "IN")
                setValue("participante", "PA")
                setValue("apellidoPaterno", "")
                setValue("apellidoMaterno", "")
            }
            else if (tipoBeneficarioWatcher === ValuesTipoBeneficiario.INSTITUCION_FINANCIERA){
                setValue("inmobiliaria", "IF")
                setValue("institucion", "")
                setValue("participante", "PA")
                setValue("apellidoPaterno", "AP")
                setValue("apellidoMaterno", "AM")
            }
            else if (tipoBeneficarioWatcher === ValuesTipoBeneficiario.INMOBILIARIA){
                setValue("inmobiliaria", "")
                setValue("institucion", "IN")
                setValue("participante", "PA")
                setValue("apellidoPaterno", "AP")
                setValue("apellidoMaterno", "AM")
            }
            else if (tipoBeneficarioWatcher === ValuesTipoBeneficiario.PARTICIPANTE){
                setValue("inmobiliaria", "IF")
                setValue("institucion", "IN")
                setValue("participante", "")
                setValue("apellidoPaterno", "")
                setValue("apellidoMaterno", "")
            }
        }  
        setIsEditingDefining(false);
    }, [tipoBeneficarioWatcher])

    useEffect(() => {
        getDetalleParticipante();
    }, [participanteWatcher])

    const getDetalleParticipante = async () => {
        const personaSplited = participanteWatcher.split("/")
        if (personaSplited.length === 2){
            const rutParticipante = participanteWatcher.split("/")[0]
            const tipoParticipante = parseInt(participanteWatcher.split("/")[1])
            const filter : ParticipanteRequest = {mutuoId: idMutuo, rut: rutParticipante, codigoTipoParticipante: tipoParticipante}
            const response = await buscarParticipante(filter);
            const data = response?.data;
            setValue("rut", data?.rut ?? "")
            setValue("nombre", data?.nombres ?? "")
            setValue("apellidoMaterno", data?.apellidomaterno ?? "")
            setValue("apellidoPaterno", data?.apellidopaterno ?? "")
            setValue("monto", 0)
        }
    }

    const handleSubmitForm = (form : FormularioBeneficiarioModel) => {
        if (isCreating){
            onSubmit(form);
            return;
        }
        onUpdate(form);
    }

    const handleCancelForm = () => {
        setModalConfirmacion({
            show: true,
            title: 'Cancelar Operación',
            message: `¿Estás seguro de querer cancelar? Los datos ingresados no serán almacenados`,
            metodo: () => {
                onHide();
            },
        });
    }

    return (
        <>
            <ModalInmobiliarias
                show={showModalInmobiliaria}
                onHide={() => setShowModalInmobiliaria(false)}
                setTablaSeleccionada={setTablaSeleccionada}
            />
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({ ...modalConfirmacion, show: false })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                message={modalConfirmacion.message}
                title={modalConfirmacion.title}
            />
            <Dialog
                open={show}
                onClose={onHide}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>
                    {isCreating ? 'Agregar Beneficiario' : 'Editar Beneficiario'}
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit(handleSubmitForm)}>
                        <Grid2 container spacing={2} sx={{ mt: 2 }}>
                            <Grid2 size={{ xs: 12, lg: 4}}>
                                <InputSelect
                                    name="tipoBeneficario"
                                    label="Tipo Beneficario"
                                    control={control}
                                    options={[
                                        { value: ValuesTipoBeneficiario.PERSONA_NATURAL, label: "Persona natural" },
                                        { value: ValuesTipoBeneficiario.INSTITUCION_FINANCIERA, label: "Institución financiera" },
                                        { value: ValuesTipoBeneficiario.INMOBILIARIA, label: "Inmobiliaria" },
                                        { value: ValuesTipoBeneficiario.PARTICIPANTE, label: "Participante" }
                                    ]}
                                    onChange={(value) => setValue("tipoBeneficario", value ?? "")}
                                    error={errors.tipoBeneficario}
                                />
                            </Grid2>
                            {
                                tipoBeneficarioWatcher === ValuesTipoBeneficiario.PERSONA_NATURAL ?
                                <>
                                    <Grid2 size={{ xs: 12, lg: 4 }}>
                                        <InputRut 
                                            name="rut" 
                                            control={control} 
                                            label='Rut'
                                            error={errors.rut}/>
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, lg: 4 }}>
                                        <InputText
                                            label="Nombre"
                                            name="nombre"
                                            control={control}
                                            error={errors.nombre}
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, lg: 4 }}>
                                        <InputText
                                            label="Apellido Paterno"
                                            name="apellidoPaterno"
                                            control={control}
                                            error={errors.apellidoPaterno}
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, lg: 4 }}>
                                        <InputText
                                            label="Apellido Materno"
                                            name="apellidoMaterno"
                                            control={control}
                                            error={errors.apellidoMaterno}
                                        />
                                    </Grid2>
                                </>
                                : tipoBeneficarioWatcher !== '' ?
                                    <>
                                        {
                                            tipoBeneficarioWatcher === ValuesTipoBeneficiario.INSTITUCION_FINANCIERA ? 
                                            <Grid2 size={{ xs: 12, lg: 8 }}>
                                                <InputSelect
                                                    label="Institución Financiera"
                                                    name="institucion"
                                                    control={control}
                                                    options={listInstitucionFinan}
                                                    error={errors.institucion}
                                                />
                                            </Grid2>
                                            : tipoBeneficarioWatcher === ValuesTipoBeneficiario.INMOBILIARIA ?
                                            <>
                                                <Grid2 size={{xs:12, lg: 7}}>
                                                    <InputText
                                                        label="Inmobiliaria"
                                                        name="inmobiliaria"
                                                        control={control}
                                                        error={errors.inmobiliaria}
                                                        desabilitado
                                                    />
                                                </Grid2>
                                                <Grid2 size={{ xs: 12, lg:  1 }} sx={{ mt: 3 }}>
                                                    <MButton
                                                        type='button'
                                                        variant='contained'
                                                        color='primary'
                                                        children={<SearchIcon fontSize="small" />}
                                                        onClick={() => setShowModalInmobiliaria(true)}
                                                    />
                                                </Grid2>
                                            </>
                                            : <>
                                                <Grid2 size={{ xs: 12, lg: 8 }}>
                                                    <InputSelect
                                                        label="Participante"
                                                        name="participante"
                                                        control={control}
                                                        options={participantes}
                                                        error={errors.participante}
                                                    />
                                                </Grid2>
                                            </>
                                        }
                                        <Grid2 size={{ xs: 12, lg: 4 }}>
                                            <InputRut 
                                                name="rut" 
                                                control={control} 
                                                label='Rut'
                                                error={errors.rut}
                                                disabled/>
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 4 }}>
                                            <InputText
                                                label={"Nombre " + tipoBeneficarioWatcher.toLowerCase()}
                                                name="nombre"
                                                control={control}
                                                error={errors.nombre}
                                                desabilitado
                                            />
                                        </Grid2>
                                        {
                                            tipoBeneficarioWatcher === ValuesTipoBeneficiario.PARTICIPANTE ?
                                            <>
                                                <Grid2 size={{ xs: 12, lg: 4 }}>
                                                    <InputText
                                                        label={"Apellido paterno " + tipoBeneficarioWatcher.toLowerCase()}
                                                        name="apellidoPaterno"
                                                        control={control}
                                                        error={errors.apellidoPaterno}
                                                        desabilitado
                                                    />
                                                </Grid2>
                                                <Grid2 size={{ xs: 12, lg: 4 }}>
                                                    <InputText
                                                        label={"Apellido materno " + tipoBeneficarioWatcher.toLowerCase()}
                                                        name="apellidoMaterno"
                                                        control={control}
                                                        error={errors.apellidoMaterno}
                                                        desabilitado
                                                    />
                                                </Grid2>
                                            </>
                                            : <></> 
                                        }
                                    </>
                                : <></>       
                            }   
                            {
                                tipoBeneficarioWatcher !== '' ?
                                <Grid2 size={{ xs: 12, lg: 4 }}>
                                    <InputNumber 
                                        label="Monto a Pagar"
                                        name="monto"
                                        control={control}
                                        error={errors.monto}
                                        prefix='CLP'
                                        minValue={0}
                                        maxValue={9999999999}
                                        decimales={4}
                                        presicion={14}
                                    />
                                </Grid2> : <></>
                            }
                            
                        </Grid2>
                        <Grid2 size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "15px" }}>
                            <MButton onClick={handleCancelForm} variant="contained" color="error">
                                Cancelar
                            </MButton>
                            <MButton type="submit" variant="contained" color="primary" style={{marginLeft: "10px"}}>
                                {isCreating ? 'Agregar' : 'Editar'}
                            </MButton>
                        </Grid2>
                    </form> 
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ModalLiquidacion;